<div class="container-map">
  <div #map class="map-box-gl"></div>
  <pre #coordinates class="coordinates"></pre>
</div>